const SOCIAL_LINK = {
  github: "https://github.com/grindytech",
  x: "https://x.com/grindytech",
};

// MAINNET
const NETWORK = 1;

const EXPLORER = "https://etherscan.io/";
const INFURA = "https://mainet.infura.io/v3/b290a50e9362493e8882b002b9e44eb3";
const EMAIL_REGEX = /^\s*(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/;

export { NETWORK, EXPLORER, INFURA, SOCIAL_LINK, EMAIL_REGEX };
